<template>
	<div>
		<div class="row">
			<div class="col-lg-4">
				<label for="">Fecha *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoHerramienta.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-5">
				<label for="">Nombre</label>
				<input type="text" class="form-control" v-model="VehiculoHerramienta.Nombre"/>
			</div>
			<div class="col-lg-3">
				<label>Cantidad *</label>
				<vue-numeric
					class="form-control"
					separator=","
					placeholder="0"
					:precision="0"
					v-model="VehiculoHerramienta.Cantidad"
				></vue-numeric>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-4">
				<label>Estatus</label>
				<select v-model="VehiculoHerramienta.Estatus" class="form-control">
					<option value="">- Estatus -</option>
					<option value="1">Bueno</option>
					<option value="2">Regular</option>
					<option value="3">Malo</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoHerramienta.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-5">
				<label for="">Fecha de Renovación *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoHerramienta.FechaRenovacion" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoHerramienta.Observaciones" cols="10" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Herramienta",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Herramienta',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoHerramienta:{
                IdVehiculoHerramienta:0,
                IdVehiculo:0,
                Fecha:'',
				FechaRenovacion:'',
				Nombre:'',
				Cantidad:0,
				Estatus:'',
				Valor:0,
                Observaciones:'',
            },
            errorvalidacion:[]
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
            if (this.VehiculoHerramienta.Fecha!='' && this.VehiculoHerramienta.Fecha!=undefined) {
                let day=this.VehiculoHerramienta.Fecha.getDate();
                let month=this.VehiculoHerramienta.Fecha.getMonth()+1;
                let year=this.VehiculoHerramienta.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			let FechaRenovacion='';
            if (this.VehiculoHerramienta.FechaRenovacion!='' && this.VehiculoHerramienta.FechaRenovacion!=undefined) {
                let day=this.VehiculoHerramienta.FechaRenovacion.getDate();
                let month=this.VehiculoHerramienta.FechaRenovacion.getMonth()+1;
                let year=this.VehiculoHerramienta.FechaRenovacion.getFullYear();
                FechaRenovacion=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoHerramienta',this.VehiculoHerramienta.IdVehiculoHerramienta);
            formData.set('IdVehiculo',this.VehiculoHerramienta.IdVehiculo);
            formData.set('Valor',this.VehiculoHerramienta.Valor);
			formData.set('Nombre',this.VehiculoHerramienta.Nombre);
			formData.set('Cantidad',this.VehiculoHerramienta.Cantidad);
			formData.set('Estatus',this.VehiculoHerramienta.Estatus);
            formData.set('Observaciones',this.VehiculoHerramienta.Observaciones);
            formData.set('Fecha',Fecha);
			formData.set('FechaRenovacion',FechaRenovacion);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculoherramienta/post',formData).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Herramienta").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoHerramienta={
                IdVehiculoHerramienta:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Valor:0,
                Observaciones:'',
				FechaRenovacion:new Date(),
				Nombre:'',
				Cantidad:0,
				Estatus:'',
            }
        },
		Recuperar(){
            this.$http.get('vehiculoherramienta/recovery',{
                params:{
                    IdVehiculoHerramienta:this.VehiculoHerramienta.IdVehiculoHerramienta
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculoherramienta;
                this.VehiculoHerramienta.IdVehiculoHerramienta=objres.IdVehiculoHerramienta;
                this.VehiculoHerramienta.IdVehiculo=objres.IdVehiculo;
                this.VehiculoHerramienta.Valor=objres.Valor;
				this.VehiculoHerramienta.Nombre=objres.Nombre;
				this.VehiculoHerramienta.Cantidad=objres.Cantidad;
				this.VehiculoHerramienta.Estatus=objres.Estatus;
                this.VehiculoHerramienta.Observaciones=objres.Observaciones;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoHerramienta.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaRenovacion.replace(/-/g, "\/");
                this.VehiculoHerramienta.FechaRenovacion=new Date(formatedDate2);
            })
        },
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoHerramienta.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoHerramienta.IdVehiculoHerramienta = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
